export default "__VITE_ASSET__CtD2pRxP__"